export default {
  new_conversation: 'New conversation',
  open_modal: 'Open Direct Messaging',
};
